import type { ItemOriginEnum, ItemTypeEnum } from "@shared/graphql.types";
import type { LocaleOfStoreType } from "@beautypie/core";
import { addBasketItemsWithSpinner } from "lib/api";
import { navigateTo } from "@shared/utils.routing";
import { activeVariants } from "@membership/constants";

const GIFT_MEMBERSHIP_SKUS = {
  uk: "BP_PLUS_GIFT_UK",
  us: "BP_PLUS_GIFT_US"
};

export const onAddToBag =
  ({
    variant,
    isGiftMembership,
    locale,
    hasMembership,
    setConfirmation
  }: {
    variant: { id: string; sku: string; maxItemQuantity: number };
    setConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
    isGiftMembership: boolean;
    locale: LocaleOfStoreType;
    hasMembership?: boolean;
  }) =>
  async ({
    membershipSKU,
    locationTypeDetails = "pdp-header"
  }: {
    membershipSKU: string;
    locationTypeDetails?: string;
  }) => {
    if (isGiftMembership) {
      const { giftMembershipProductId } = activeVariants[locale];

      await addBasketItemsWithSpinner([
        {
          quantity: 1,
          variantId: giftMembershipProductId,
          variantSku:
            locale === "en-US"
              ? GIFT_MEMBERSHIP_SKUS.us
              : GIFT_MEMBERSHIP_SKUS.uk,
          type: "product",
          origin: "user"
        }
      ]).then(() => navigateTo("/basket"));

      return;
    }

    const item = {
      quantity: 1,
      variantId: variant.id,
      variantSku: variant.sku,
      maxItemQuantity: variant.maxItemQuantity,
      type: "product",
      origin: "user"
    } as const;

    const getMembershipAsBasketItem = (sku?: string) => {
      return {
        origin: "user" as ItemOriginEnum,
        quantity: 1,
        type: "membership" as ItemTypeEnum,
        membershipId: sku,
        variantSku: sku
      };
    };

    if (membershipSKU) {
      const openGateMembership = getMembershipAsBasketItem(membershipSKU);
      const items = hasMembership ? [item] : [item, openGateMembership];
      await addBasketItemsWithSpinner(items, "page", locationTypeDetails, {
        explicitUserMembershipAdd: true
      }).then(() => {
        setConfirmation(true);
      });

      return;
    } else {
      await addBasketItemsWithSpinner([item], "page", locationTypeDetails, {
        explicitUserMembershipAdd: false
      }).then(() => {
        setConfirmation(true);
      });

      return;
    }
  };
